import { compareWithTextSensitivity } from "~/helpers/compare";
import {
  CompanyType,
  UserCompaniesInfoType,
  UserCompanyInfo,
} from "../types/login";

export const loginDtoToViewModel = (
  userCompanyInfos: UserCompaniesInfoType[],
  userName: string,
): UserCompanyInfo[] => {
  return userCompanyInfos
    .map(
      (c) =>
        ({
          companyId: c.companyId,
          companyName: c.companyName,
          companyType: c.companyType,
          token: c.tokenObject.token,
          userName,
          userId: c.userId,
          companyLogoURL: c.companyLogoURL,
        }) as UserCompanyInfo,
    )
    .filter((c) => c.companyType === CompanyType.Steel)
    .sort((a, b) =>
      compareWithTextSensitivity(a.companyName, b.companyName, "asc"),
    );
};
